import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import {
  CLEANUP_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import { toastSuccess, toastError } from "../../common/Toast";

const CompleteSaleModal = ({
  CleanupConformationApiUrl,
  handleCompleteSale,
  handleSubmit,
  disabled,
}) => {
  //   console.log("selectedOption", selectedOption);
  let navigate = useNavigate();
  const paramObject = useParams();

  const handleOk = () => {
    handleCompleteSale();
    handleSubmit();

    // navigate("/receiving-receipt/:id");
  };

  return (
    <>
      <div
        className="modal fade"
        id="CompleteModal"
        tabIndex={-1}
        aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h6>
                    Are you sure you want to submit this receiving? This cannot
                    be undone.
                  </h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                // disabled={disabled}
                type="button"
                // onClick={() => {
                //   handleOk();
                // }}
                onClick={() => {
                  if (disabled !== true) {
                    handleOk();
                  }
                }}
              >
                OK
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteSaleModal;
